import { Link } from "react-router-dom"
import { BASE_URL } from "./constants"
export const homeTourSteps = [
    {
        selector: '.general-step-start',
        content: (
            <div>
                <h3>Benvenuto!</h3> 
                <p>Ti guideremo ora in un piccolo tour di tutte le sezioni del pannello amministrativo, usa il pulsante <strong>Avanti</strong> per proseguire negli step ed interagisci con gli elementi quando richiesto!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.general-step-0',
        content: (
            <div>
                <h3>Formazione</h3> 
                <p>Crea i tuoi percorsi, carica il materiale e crea i tuoi quiz, dai vita a percorsi personalizzati per i tuoi utenti</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.general-step-1',
        content: (
            <div>
                <h3>Verifica</h3> 
                <p>Crea le tue prove, carica le domande e personalizza la struttura!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.general-step-2',
        content: (
            <div>
                <h3>Utenti</h3> 
                <p>Gestisci i tuoi utenti, i gruppi ed i permessi di accesso!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.general-step-3',
        content: (
            <div>
                <h3>Personalizza</h3> 
                <p>Personalizza il software, nome, logo, colori, puoi fare tutto!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.general-step-4',
        content: (
            <div>
                <h3>Report</h3> 
                <p>Monitora l'attività degli utenti, i progressi e l'utlizzo della piattaforma!</p>
                <Link to={'/folders'}>
                    <button className="secondary">
                        Prosegui con il tour
                    </button>
                </Link>
            </div>
        ),
        position: 'right',
    }
]

export const trainingsTourSteps = (id) => [
    {
        selector: '.trainigs-step-0',
        content: (
            <div>
                <h3>La home dei percorsi</h3> 
                <p>Qui trovi tutti i percorsi creati, ogni cartella corrisponde a un percorso o a un raggruppamento di percorsi, anche qui puoi aggiungere dei materiali visibili a tutti!</p>
            </div>
        ),
        position: 'bottom',
    },
    {
        selector: '.trainigs-step-1',
        content: (
            <div>
                <h3>Aggiungi tutto!</h3> 
                <p>In ogni cartella, da qui puoi aggiungere materiali, quiz di allenamento e sottocartelle!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.trainigs-step-2',
        content: (
            <div>
                <h3>Apri una cartella</h3> 
                <p><strong>Clicca sulla cartella</strong> per visualizzarne il contenuto e gestirla!</p>
            </div>
        ),
        disableNext: true,
        position: 'right',
    },
    {
        selector: '.trainigs-step-3',
        content: (
            <div>
                <h3>Il nome della cartella</h3> 
                <p>Ogni cartella ha un nome e un'icona che puoi personalizzare da qui!</p>
            </div>
        ),
        position: 'right'
    },
    {
        selector: '.trainigs-step-4',
        content: (
            <div>
                <h3>Allenamento</h3> 
                <p>Quiz per valutare la preparazione dell’utente prima dello svolgimento della verifica finale.</p>
                <a href={`${BASE_URL}/training/perform/${id}`} target="_blank">
                    <button className="secondary">
                        Mostra vista utente
                    </button>
                </a>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.trainigs-step-5',
        content: (
            <div>
                <h3>Materiali di studio</h3> 
                <p>Nell’applicativo possono essere inseriti materiali di differenti tipologie, dai video al pdf ai link.</p>
                <a href={`${BASE_URL}/folder/${id}`} target="_blank">
                    <button className="secondary">
                        Mostra vista utente
                    </button>
                </a>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.trainigs-step-6',
        content: (
            <div>
                <h3>Cartelle interne</h3> 
                <p>Ogni cartella può avere più sotto cartelle per organizzare al meglio i materiali!</p>
                
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.trainigs-step-7',
        content: (
            <div>
                <h3>Vedi i destinatari</h3> 
                <p>Per ogni cartella puoi assegnare i permessi di accesso divisi per utenti e gruppi di utenti!</p>
                
            </div>
        ),
        position: 'right',
    }
]

export const examsTourSteps = (id, setCurrentStep=null) => [
    {
        selector: '.exams-step-0',
        content: (
            <div>
                <h3>Filtra le verifiche</h3> 
                <p>Puoi filtrare le verifiche in base al loro stato!</p>
            </div>
        ),
        position: 'bottom',
    },
    {
        selector: '.exams-step-1',
        content: (
            <div>
                <h3>Seleziona la verifica</h3> 
                <p><strong>Clicca su una verifica</strong> per selezionarla e poterla modificare o monitorare!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.exams-step-2',
        content: (
            <div>
                <h3>Apri, monitora ed elimina</h3> 
                <p>Da qui puoi accedere alla modifica di una prova, puoi vederne i risultati opure eliminarla! Ora clicca su Apri per proseguire con il tour.</p>
            </div>
        ),
        disableNext: true,
        position: 'right',
    },
    {
        selector: '.exams-step-3',
        content: (
            <div>
                <h3>Impostazioni della prova</h3> 
                <p>Da qui puoi definire le impostazioni generali della prova, il nome, le date di disponibilità e le modalità di estrazione e revisione delle domande!</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.exams-step-4',
        content: (
            <div>
                <h3>Destinatari</h3> 
                <p>Scegli se mostrare la prova a tutti, solo a qualche gruppo o solo a singoli utenti</p>
            </div>
        ),
        position: 'right',
        action: ()=>{
            if(setCurrentStep !== null && setCurrentStep !== undefined)
                setCurrentStep(1)
        },
    },
    {
        selector: '.exams-step-5',
        content: (
            <div>
                <h3>Quesiti della prova</h3> 
                <p>Puoi creare le domande direttamente da qui, importare lall'excel oppure farti aiutare dall'AI!</p>
            </div>
        ),
        position: 'right',
        action: ()=>{
            if(setCurrentStep !== null)
                setCurrentStep(2)
        },
    },
    {
        selector: '.exams-step-6',
        content: (
            <div>
                <h3>Struttura della prova</h3> 
                <p>Da qui puoi definire i dettagli della prova, i tempi, i punteggi e molto altro...</p>
            </div>
        ),
        action: ()=>{
            if(setCurrentStep !== null)
                setCurrentStep(3)
        },
        position: 'right',
    },
    {
        selector: '.exams-step-7',
        content: (
            <div>
                <h3>Pubblica la tua prova</h3> 
                <p>Quando sei pronto puoi pubblicare la prova da qui e sarà subito disponibile agli utenti!</p>
                <a href={`${BASE_URL}/exams/preview/${id}`} target="_blank">
                    <button className="secondary">
                        Mostra vista utente
                    </button>
                </a>
            </div>
        ),
        position: 'right',
    }
]

export const usersTourSteps = (navigate=null) => [
    {
        selector: '.users-step-0',
        content: (
            <div>
                <h3>Utenti iscritti</h3> 
                <p>Qui troverai gli utenti che si iscriveranno alla tua piattaforma. Potrai decidere se accettarli in automatico o manualmente da “In attesa”.</p>
            </div>
        ),
        position: 'bottom',
    },
    {
        selector: '.users-step-1',
        content: (
            <div>
                <h3>Dettagli utente</h3> 
                <p>Facendo doppio click sull'utente potrai visualizzarne il dettaglio!</p>
            </div>
        ),
        actionAfter: ()=>{
            if(navigate !== null)
                navigate("/users/groups")
        },
        position: 'bottom',
    },
    {
        selector: '.users-step-2',
        content: (
            <div>
                <h3>Gruppi</h3> 
                <p>Qui puoi creare i gruppi con i tuoi utenti, in base agli accessi che vuoi fornire loro sulla piattaforma.</p>
            </div>
        ),
        position: 'right',
    },
    {
        selector: '.users-step-3',
        content: (
            <div>
                <h3>Impostazioni</h3> 
                <p>Accedi alle impostazioni per gestire le modalità di accesso</p>
            </div>
        ),
        disableNext: true,
        position: 'right',
    },
    {
        selector: '.users-step-4',
        content: (
            <div>
                <h3>Criteri di accesso e dati</h3> 
                <p>Da qui puoi definire le modalità di accesso alla piattaforma ed i dati che verranno richiesti agli utenti!</p>
            </div>
        ),
        position: 'right',
    }
]

export const personalizationTourSteps = (setActiveKey=null) => [
    {
        selector: '.personalizations-step-0',
        content: (
            <div>
                <h3>Gestici la piattaforma</h3> 
                <p>Da qui, spostandoti tra le varie sezioni puoi modificare la personalizzazione dell'app!</p>
            </div>
        ),
        position: 'bottom',
    },
    {
        selector: '.personalizations-step-1',
        content: (
            <div>
                <h3>Dettagli della piattaforma</h3> 
                <p>Imposta il nome dell'app e carica il documento di privacy policy</p>
            </div>
        ),
        actionAfter: ()=>{
            if(setActiveKey !== null)
                setActiveKey("logos")
        },
        position: 'bottom',
    },
    {
        selector: '.personalizations-step-2',
        content: (
            <div>
                <h3>Imposta il logo</h3> 
                <p>Da qui puoi caricare il logo da mostrare in app e l'icona!</p>
            </div>
        ),
        position: 'right',
    }
]